import React from "react";

import "./Footer.css";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { FaLocationArrow } from "react-icons/fa";

const Footer = () => {
  const handleLocationClick = () => {
    // Redirect to Google Maps location
    window.open("https://maps.app.goo.gl/DtA7yg3N7yNKuXgE7", "_blank");
  };

  const currentYear = new Date().getFullYear();

  // const navigate = useNavigate()

  return (
    <div className="footer-main-div">
      <div className="container-md-12">
        <footer
          className=" text-lg-start "
          style={{ backgroundColor: "#1c2331", textAlign: "center" }}
        >
          <section style={{ background: "#181818" }}>
            <div className="container  text-md-start mt-5">
              <div style={{display:'flex', flexDirection:'row', alignItems:'flex-start', flexWrap:'wrap', width:'100%', gap:'20px 0'}}>
                {/* <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4 foot_logo">
                  <img width={'300px'} className="Company-logo" src="/NewImages/logo2.png" alt="" />
                  <div className="payment-scanner">
                    <img className="footer-in-payment-method" src="./images/footer-in-payment-method.jpg" alt="" />
                  </div>
                </div> */}

                <div style={{flex:'0 0 20%', maxWidth:'20%', minWidth:'180px', padding:'0 15px'}}>
                  <div className="Company-logo">
                    <img
                      style={{ marginBottom: "50px" }}
                      width={"400px"}
                      className="Company-logo"
                      src="./images/metablock-logo-main-transformed.webp"
                      // src="../images/metablock-logos-main.webp"
                      alt="metablocktechnologies logo"
                    />
                  </div>
                  <div className="payment-method">
                    <div class="image-container">
                      <img
                        className="footer-in-payment-method"
                        src="./images/QRCode.jpg"
                        alt="Metablock scanner | metablocktechnologies"
                      />
                      <div class="overlay-text">Scan Me</div>
                      <p style={{ fontSize: "15px", textAlign: "center" }}>
                        Save Contact Details
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{flex:'0 0 18%', maxWidth:'18%', minWidth:'150px', padding:'0 15px'}}>
                  <h6 className="text-uppercase fw-bold">Products</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{ width: 60, backgroundColor: "#7c4dff", height: 2 }}
                  />
                  <p>
                    <Link to="/web-development-company">
                      <span className=" footer-in-Pages">WEBSITE</span>
                    </Link>
                  </p>

                  <p>
                    <Link to="/software-development-services">
                      <span className=" footer-in-Pages">SOFTWARE</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/blockchaindevelopment">
                      <span className=" footer-in-Pages">BLOCKCHAIN</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/mobile-app-development-services">
                      <span className="footer-in-Pages">APPLICATION</span>
                    </Link>
                  </p>
                  <p className="footer-contact-number">
                    <Link to="/MetaverseDevelopment">
                      <span className="footer-in-Pages">METAVERSE</span>
                    </Link>
                  </p>

                  {/* <p className="footer-contact-number">
                    <Link to="/GameDevelopment">
                      <span className="footer-in-Pages">GAME</span>
                    </Link>
                  </p> */}
                </div>

                <div style={{flex:'0 0 22%', maxWidth:'22%', minWidth:'180px', padding:'0 15px'}}>
                  <h6 className="text-uppercase fw-bold">Useful links</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{ width: 60, backgroundColor: "#7c4dff", height: 2 }}
                  />

                  <p className="footer-contact-number">
                    <Link to="/contact-us">
                      <span className="footer-in-Pages">CONTACT US</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/Aboutus">
                      <span className="footer-in-Pages">ABOUT US</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/sitemap">
                      <span className="footer-in-Pages">SITEMAP</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/gallery">
                      <span className="footer-in-Pages">GALLERY</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/InsightsFAQ">
                      <span className="footer-in-Pages">FAQ</span>
                    </Link>
                  </p>

                  <p className="footer-contact-number">
                    <Link to="/PrivacyPolicy">
                      <span className="footer-in-Pages">PRIVACY POLICY</span>
                    </Link>
                  </p>
                  <p className="footer-contact-number">
                    <Link to="/RefundPolicy">
                      <span className="footer-in-Pages">REFUND POLICY</span>
                    </Link>
                  </p>
                  <p className="footer-contact-number">
                    <Link to="/TermAndCondition">
                      <span className="footer-in-Pages">TERMS & CONDITION</span>
                    </Link>
                  </p>
                </div>

                <div style={{flex:'0 0 30%', maxWidth:'30%', minWidth:'220px', padding:'0 15px'}}>
                  <h6 className="text-uppercase fw-bold">Contact</h6>
                  <hr
                    className="mb-4 mt-0 d-inline-block mx-auto"
                    style={{ width: 60, backgroundColor: "#7c4dff", height: 2 }}
                  />
                  <p>
                    <i className="fas fa-home mr-3" />
                    30-A, Gopalpura Bypass Rd, opp. Holiday Inn Hotel, opp.
                    Holiday Inn, Sultan Nagar, Santi Nagar, Gurjar Ki Thadi,
                    Jaipur, Rajasthan 302020{" "}
                    <FaLocationArrow
                      onClick={handleLocationClick}
                      style={{
                        background: "red",
                        cursor: "pointer",
                        borderRadius: "2px",
                      }}
                    />
                  </p>
                  <a
                    href="mailto:info@metablocktechnologies.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="footer-contact-number">
                      <i className="fas fa-envelope mr-3" />
                      info@metablocktechnologies.in
                    </p>
                  </a>
                  <a
                    href="tel:+91-93585 93003 "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="footer-contact-number">
                      <i className="fas fa-phone mr-3" />
                      +91 935 859 3003
                    </p>
                  </a>
                  <a
                    href="tel:+91-93585 93002"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="footer-contact-number">
                      <i className="fas fa-phone mr-3" />
                      +91 935 859 3002
                    </p>
                  </a>
                  <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'12px', marginTop:'10px', flexWrap:'wrap'}}>
                    <a
                      href="https://www.facebook.com/metablocktechnologies"
                      target="_blank" rel="noopener noreferrer"
                    >
                      <img
                        className="w-7 sm:w-6"
                        src="./images/facebook2.webp"
                        alt="Facebook logo | metablocktechnologies"
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/metablocktechnologies1?igsh=Zmxva3Fnd3o1NzBw"
                      target="_blank" rel="noopener noreferrer"
                    >
                      <img
                        className="w-7 sm:w-6"
                        src="./images/instagram2.webp"
                        alt="Instagram logo | metablocktechnologies"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/metablocktechnologies"
                      target="_blank" rel="noopener noreferrer"
                    >
                      <img
                        className="w-7 sm:w-6"
                        src="./images/linkedin2.webp"
                        alt="LinkedIn logo | metablocktechnologies"
                      />
                    </a>
                    <a
                      href="https://wa.me/919358593003"
                      target="_blank" rel="noopener noreferrer"
                    >
                      <img
                        className="w-7 sm:w-6"
                        src="./images/whatsapp3.webp"
                        alt="WhatsApp logo | metablocktechnologies"
                      />
                    </a>
                    <a
                      href="#"
                      target="_blank" rel="noopener noreferrer"
                    >
                      <img
                        className="w-7 sm:w-6"
                        src="./images/skype-button.webp"
                        alt="Skype logo | metablocktechnologies"
                      />
                    </a>
                  </div>
                  
                </div>
                
                
              </div>
            </div>
            <p className="text-right mr-36">© {currentYear} Metablock Technologies LLP. All rights reserved.</p>
          </section>
          
        </footer>
      </div>
    </div>
  );
};

export default Footer;
